"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlToReactTransformer = void 0;
const features_1 = require("../features");
const react_1 = __importDefault(require("react"));
const propsDictionaryDefault = {
    class: 'className',
};
class HtmlToReactTransformer extends features_1.Transformer {
    constructor(componentDictionary = null, propsDictionary = propsDictionaryDefault) {
        super();
        this.parseFn = (nodeType, attributes, children) => {
            const parsedAttributes = attributes.reduce((acc, attribute) => {
                const key = this.propsDictionary[attribute.attribute] || attribute.attribute;
                acc[key] = attribute.value;
                return acc;
            }, {});
            const parsedNodeType = (this.componentDictionary && this.componentDictionary[nodeType]) || nodeType;
            return react_1.default.createElement(parsedNodeType, { key: (0, features_1.createUUID)(), ...parsedAttributes }, children);
        };
        this.componentDictionary = componentDictionary;
        this.propsDictionary = propsDictionary;
        this.htmlTextTransformer = new features_1.HtmlTextTransformer(this.parseFn);
    }
    transformation(message) {
        return this.htmlTextTransformer.resolve(message);
    }
}
exports.HtmlToReactTransformer = HtmlToReactTransformer;
//# sourceMappingURL=HtmlToReactTransformer.js.map